import { PiSignOutBold } from 'react-icons/pi';
import { Popover } from 'antd';
import { logout, selectCurrentUser } from '@src/store/user/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Image } from './Image';
import { renderImage } from '@src/utilities/renderImage';
import { useAppTranslate } from '@src/i18n/i18n';
import { useAuth0 } from '@auth0/auth0-react';
import { SELECTED_SIDEBAR_ITEM } from '@src/constants/localStorage';

export function UserInfo() {
    const { t } = useAppTranslate();
    const dispatch = useDispatch();
    const { logout: authLogout } = useAuth0();
    const [open, setOpen] = useState(false);
    const user = useSelector(selectCurrentUser);
    const [renderImg, setRenderImg] = useState(
        <Image avatar_src={'avatar'} isImageRender={false} />
    );

    useEffect(() => {
        if (user && user.picture) {
            const { picture } = user;
            renderImage(picture)
                .then(() => {
                    setRenderImg(
                        <Image avatar_src={picture} isImageRender={true} />
                    );
                })
                .catch((err) => {
                    console.error('err', err);
                });
        }
    }, [user]);

    const handleSingOut = () => {
        dispatch(logout(undefined));
        authLogout({
            logoutParams: {
                returnTo: window.location.origin,
            },
        });
        handleOpenChange(false);
        localStorage.removeItem(SELECTED_SIDEBAR_ITEM);
    };

    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen);
    };

    const userContent = (
        <div>
            <div className="max-w-[280px] sm:max-w-full">
                <div className="border-b border-primary/20 py-2 italic">
                    {user?.email}
                </div>
                <ul className="mb-0">
                    <li className="border-t border-primary/20">
                        <Link
                            to="#"
                            className="inline-flex items-center text-primary appearance-none rounded-md text-light
                 w-full px-3 py-2 mt-2 text-sm transition-all ease-in-out delay-150 hover:bg-gray-100 hover:text-primary"
                            onClick={(e) => {
                                e.preventDefault();
                                handleSingOut();
                            }}
                        >
                            <PiSignOutBold className="w-4 h-4 mr-3" />
                            {t('keyTerms.signOut')}
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );

    return (
        <div className="flex items-center justify-between flex-row">
            <Popover
                placement="bottomRight"
                content={userContent}
                arrow={false}
                trigger={'click'}
                open={open}
                onOpenChange={handleOpenChange}
            >
                <div className="flex flex-row items-center space-x-1">
                    {renderImg}
                </div>
            </Popover>
        </div>
    );
}
